import { render, staticRenderFns } from "./PrintBPJSReferralDialog.vue?vue&type=template&id=5b7b87d6"
import script from "./PrintBPJSReferralDialog.vue?vue&type=script&lang=js"
export * from "./PrintBPJSReferralDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports